import { YjsEditor } from '@slate-yjs/core';
import { useEditorPlugin, usePluginOption } from '@udecode/plate/react';
import React from 'react';

import { BaseYjsPlugin, type YjsConfig } from './yjsPlugin';

export const YjsAboveEditable: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
    const { editor } = useEditorPlugin<YjsConfig>(BaseYjsPlugin);

    const provider = usePluginOption(BaseYjsPlugin, 'provider');

    React.useEffect(() => {
        YjsEditor.connect(editor as any);

        return () => YjsEditor.disconnect(editor as any);
    }, [provider.awareness, provider.document]);

    return <>{children}</>;
};
